export default {
  en: {
    copyToClipboard: 'Copy to clipboard',
    copied: 'Copied',
  },
};
